import { loadingAsyncState, HttpResult, AsyncState, unloadedAsyncState } from "widgets-for-react";
import { FormState, FormData as FormDataType } from "./types";
import * as Immutable from 'immutable'
import * as i18next from 'i18next'
import { getLangFromUrl } from "../publicSite/utils/history.mod";
import { getDrupalLanguage } from "../drupal/types_and_parser/extra_types.mod"

export let postFormSubmissionState = (form_id:number, form_state:FormState) : AsyncState<string> => {
  if(form_state.form_data.kind != "loaded") return unloadedAsyncState()
  //if(!form_state.form_data.value.form.store_submissions_locally) return unloadedAsyncState()
  let steps = form_state.form_data.value.steps
  let userEmail = ""
  let ConfirmationEmail = ""
  let files:Immutable.List<File> = Immutable.List<File>()
  form_state.form_data.value.steps.forEach(s => s.fields.forEach(f => {
    if(f.Kind == "UserEmail")
      userEmail = f.user_input
    if ((f.Kind == "Checkbox") && (((f.title.toUpperCase().indexOf("CONF")>-1)||(f.title.toUpperCase().indexOf("BEVESTIGING")>-1)) && (f.title.toUpperCase().indexOf("MAIL")>-1) ))
      ConfirmationEmail= f.user_input
    if(f.Kind == "Attachement" && f.file != undefined)
      for (var c = 0; c < f.file.length; c++) {
        files = files.push(f.file[c])
      }
  }))
  let raw_content = JSON.stringify(
    steps.map(s => (
      {
        fields:s.fields
                  .filter(x => x.Kind != "ReadonlyText")
                  .map(x =>
                    x.Kind == "Attachement" && x.file && x.file.length > 0 ?
                      ({...x, user_input: Array.from(x.file).map(file => file.name).join(', ')})
                    : x.Kind == "Checkbox" ?
                      x.user_input == "true" ?
                        ({...x, user_input: i18next.t("form:form_checked") })
                      : ({...x, user_input: i18next.t("form:form_not_checked")})
                    : x)})))
  let content = {
    RawContent : raw_content,
    UserEmail : userEmail,
    ConfirmationEmail : ConfirmationEmail,
  }
  
  let obj = (form_state as any).custom_context
  for(const value in obj){
    content[value] = obj[value];
  }
  


  let formData = new FormData()
  formData.append("content", JSON.stringify(content))
  steps.forEach(x => x.fields.forEach(y => {
    if (y.Kind == "Attachement" && y.file) {
      for (var c = 0; c < y.file.length; c++) {
        formData.append(y.file[c].name, y.file[c])
      }
    } 
  }))
    
  return loadingAsyncState(async () => {
        let fetch_res = await fetch(`/api/v1/CustomFormLogic/SubmitFormData/${form_id}`, 
                                { method: 'put', 
                                  body: formData,
                                  credentials: 'include'
                                })

        if(!fetch_res.ok) {
          if (fetch_res.status == 400) {
            const value = await fetch_res.text()
            return {kind:"result", status:400, value }
          } else {
            return {kind: "failed", status: fetch_res.status}
          }
        }
        
        return {kind:"result", status:200, value:"ok"}
    })
}


export let getFormState = (events: string[], form_title: string, vacancyId: string): FormState => {
  let res: FormState = {
    form_submission_logic: unloadedAsyncState(),
    dependencies_state: Immutable.Map(),
    context: {
      external_options: Immutable.Map<string, string[]>().set("locationArray", events)
    },
    form_data: loadingAsyncState(async () => {
      let title = form_title
      if(title.toLowerCase().includes("vacancyapplication2")){
        title = `${form_title}-${getDrupalLanguage(getLangFromUrl())}`
      }
      let fetch_res = await fetch(`/api/v1/CustomFormLogic/GetFormData/${title}?vacancyId=${vacancyId}`, { method: 'get', credentials: 'include', headers: { 'content-type': 'application/json' } })
      if (!fetch_res.ok) return { kind: "failed", status: 400 }
      let data = await fetch_res.json()
      data.steps = data.steps.map(step =>
        ({
          ...step,
          fields: step.fields.map(f => {
            let field = f.field
            let maybe_answers = f.maybe_answers
            let result: any = null
            if (field.Kind == "SimpleDate") {
              result = { ...field, user_input: "", maybe_answers }
            }
            else if (field.Kind == "CheckboxMultiSelect") {

              let user_input = maybe_answers.map((a): string => {
                if (a.isDefaultSelected) {
                  return "[" + a.value + "]"
                }
                return ""
              })
              if (user_input.length == 0) {
                result = { ...field, user_input: "", maybe_answers }
              }
              else {
                result = { ...field, user_input: user_input.reduce((a, b) => a + b), maybe_answers }
              }
            }
            else {
              result = { ...field, user_input: field.optionalDefaultValue ? field.optionalDefaultValue : undefined, maybe_answers }
            }
            return result
          }),
          dependencies: step.dependencies.map(f => {
            return { ...f, is_met: false }
          })
        }))

      let res: HttpResult<FormDataType> = { kind: "result", status: 200, value: data }
      return res
    }),
  }
  return res as any
}

// export async function upload_files(form_id:number,upload_hash:string,files:File[]) : Promise<void> {
//   let files_data = new FormData()
//   files.forEach(file => files_data.append(file.name, file))
//   files_data.append("upload_hash", upload_hash)

//   // let allowed_extensions = ["txt", "rtf", "pdf", "doc", "docx", "odt", "tex", "wpd"]
//   // let extension = file.name.substring(file.name.lastIndexOf('.')+1, file.name.length) || file.name
//   // if (!allowed_extensions.includes(extension)) {
//   //   window.alert("This file type is not allowed")
//   //   return
//   // }

//   let headers = new Headers()
//   headers.append('X-XSRF-TOKEN', (document.getElementsByName("__RequestVerificationToken")[0] as any).value)
//   let res = await fetch(`/api/v1/CustomFormLogic/SubmitFormData/FileUpload/${form_id}`,  {
//     method: "POST",
//     body: files_data, credentials: 'include', headers: headers })

//   // TODO: We don't care that the request fails for now, since there's an unknown error in the file upload. Fix this when the fileUpload error is solved in .NET
//   // if (!res.ok) throw Error(res.statusText)

//   return
// }

// export let GetFormTitles = (events: string[]): FormState => {
//   let res: FormState = {
//     form_submission_logic: unloadedAsyncState(),
//     dependencies_state: Immutable.Map(),
//     context: {
//       external_options: Immutable.Map<string, string[]>().set("locationArray", events)
//     },
//     form_data: loadingAsyncState(async () => {
//       let fetch_res = await fetch(`/api/v1/CustomFormLogic/GetFormTitles`, { method: 'get', credentials: 'include', headers: { 'content-type': 'application/json' } })
//       if (!fetch_res.ok) return { kind: "failed", status: 400 }
//       let data = await fetch_res.json()
//       data.steps = data.steps.map(step =>
//         ({
//           ...step,
//           fields: step.fields.map(f => {
//             let field = f.field
//             let maybe_answers = f.maybe_answers
//             let result = { ...field, user_input: field.optionalDefaultValue ? field.optionalDefaultValue : undefined, maybe_answers }
//             return result
//           }),
//           dependencies: step.dependencies.map(f => {
//             return { ...f, is_met: false }
//           })
//         }))

//       let res: HttpResult<FormData> = { kind: "result", status: 200, value: data }
//       return res
//     }),
//   }
//   return res as any
// }